module.exports = __webpack_public_path__ + "static/media/06.4c55977b.png";